// extracted by css-extract-rspack-plugin
export default {"changeButton":"kkDMW","cell":"vSJOU"};